{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-pošta",
      "PLACEHOLDER": "Molim vas unesite vašu e-poštu.",
      "ERROR": "Molim vas unesite ispravnu e-poštu."
    },
    "API": {
      "SUCCESS_MESSAGE": "Veza za resetovanje lozinke je poslata na vašu e-poštu.",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
    },
    "SUBMIT": "Pošalji"
  }
}
